import { styled } from '@mui/material/styles';

const StyledWorkflowStepLabel = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;

  & * {
    margin: 0;
  }

  & > div {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
`;

export default StyledWorkflowStepLabel;
